import { queueFont } from "../queueFont";

type WelcomeHeaderProps = {
  clinicName: string;
  subtitle?: string;
  /** overlay = centered hero on single-room view; inline = normal flow (multi-room grid) */
  layout?: "overlay" | "inline";
  compact?: boolean;
  /** Shown once as a pill under the subtitle (e.g. "Morning session"). */
  sessionLabel?: string;
};

export function WelcomeHeader({
  clinicName,
  subtitle,
  layout = "overlay",
  compact = false,
  sessionLabel = "",
}: WelcomeHeaderProps) {
  return (
    <div
      className={[
        queueFont,
        "mx-auto max-w-[min(1100px,92vw)] text-center leading-[1.15] text-slate-900 antialiased",
        layout === "overlay"
          ? "absolute left-[clamp(20px,3.5vmin,64px)] right-[clamp(20px,3.5vmin,64px)] top-[clamp(72px,9vmin,140px)]"
          : compact
            ? "relative shrink-0 px-[clamp(12px,2vmin,32px)] pb-1 pt-[clamp(10px,1.6vmin,20px)]"
            : "relative shrink-0 px-[clamp(20px,3.5vmin,64px)] pb-[clamp(6px,1vmin,12px)] pt-[clamp(16px,2.5vmin,36px)]",
      ].join(" ")}
    >
      <div
        className={[
          queueFont,
          "font-extrabold tracking-wide text-[#0b3a66] [text-rendering:optimizeLegibility]",
          compact
            ? "mb-0.5 text-[clamp(18px,2.8vmin,32px)] leading-tight"
            : "mb-[clamp(4px,0.8vmin,10px)] text-[clamp(28px,4.5vmin,56px)]",
        ].join(" ")}
      >
        Welcome to {clinicName || "Our Dental Clinic"}
      </div>
      <div
        className={[
          queueFont,
          "font-bold tracking-[0.02em] text-[#334155] [text-rendering:optimizeLegibility]",
          compact
            ? "text-[clamp(12px,1.6vmin,18px)] leading-snug"
            : "text-[clamp(15px,2.2vmin,26px)]",
        ].join(" ")}
      >
        {subtitle ?? "Your smile is our priority!"}
      </div>
      {sessionLabel ? (
        <div
          className={[
            queueFont,
            "mx-auto inline-block rounded-full bg-[#e2e8f0] font-bold uppercase tracking-[0.1em] text-[#334155]",
            compact
              ? "mt-1 px-3 py-0.5 text-[clamp(11px,1.4vmin,15px)]"
              : "mt-[clamp(6px,1vmin,12px)] px-[clamp(12px,1.6vmin,22px)] py-[clamp(2px,0.4vmin,5px)] text-[clamp(13px,1.8vmin,22px)]",
          ].join(" ")}
        >
          {sessionLabel} session
        </div>
      ) : null}
    </div>
  );
}
